export default __webpack_public_path__ + "static/media/unsubscribed.cb933b8d.svg";